import { useState } from "react"
import axiosInstance from "../../../services/axios-client"
import { toast } from "react-toastify"

const useAccept = () => {
    const [payload, setPayload] = useState({})
    const handleAccept = async(setLoadingPage) => {
        try {
            let res = await axiosInstance.post(`/auth/calibrations/accept-approval`, payload)
            setLoadingPage(true)
            if (res.status == 200) {
                setLoadingPage(false)
                toast.success("Successfully accept calibration")
                setTimeout(() => {
                    window.location.reload()
                }, 1000)
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }
    }

    return {
        payload,
        setPayload,
        handleAccept,
    }
}

export default useAccept